import "moment-timezone";
import "common/services/services";
import "common/intercom/intercomModule";

export default function ExcelCtrl($timeout) {
    "ngInject";
    activate();

    function activate() {
        $timeout(() => {
            const el = document.getElementById(
                "structureAndDeliverableImporter"
            );
            el.displaySubbar = true;
        }, 50);
    }
}
